import { getDatabase, ref, set, get } from "firebase/database";
import fire from "../config/fire";

const db = getDatabase();

export const checkShopOfferLimit = async (shopId) => {
	const shopOffersRef = ref(db, `offers/byShop/${shopId}`);
	const snapshot = await get(shopOffersRef);

	let totalOffers = 0;

	if (snapshot.exists()) {
		totalOffers = Object.keys(snapshot.val()).length;
	}

	if (totalOffers >= 2) {
		throw new Error("MAX_OFFER_LIMIT");
	}

	return true;
};
/* ================= SAVE OFFER ================= */

export const saveOfferToFirebase = async (offerData) => {
	try {
		const { offerId, shopId, category, subCategory, geoHash } = offerData;

		/* ================= CHECK ACTIVE OFFERS COUNT ================= */
		// const shopOffersRef = ref(db, `offers/byShop/${shopId}`);
		// const snapshot = await get(shopOffersRef);
		// let totalOffers = 0;
		// if (snapshot.exists()) {
		// 	totalOffers = Object.keys(snapshot.val()).length;
		// }

		// /* ================= RESTRICT TO 5 OFFERS ================= */

		// if (totalOffers >= 2) {
		// 	throw new Error("You can only create maximum 2 active offers");
		// }

		/* ================= CLEAN DATA ================= */

		const cleanCategory = category?.toLowerCase()?.replace(/\s+/g, "_");
		const cleanSubCategory = subCategory
			? subCategory.toLowerCase().replace(/\s+/g, "_")
			: "all";
		const miniOfferData = {
			...offerData,
			category: cleanCategory,
			subCategory: cleanSubCategory,
		};

		/* ================= SHOP INDEX ================= */
		await set(ref(db, `offers/byShop/${shopId}/${offerId}`), miniOfferData);

		/* ================= GEOHASH INDEX ================= */
		await set(
			ref(db, `offers/byGeoHash/${geoHash}/${offerId}`),
			miniOfferData,
		);

		/* ================= MAIN OFFER DATA ================= */
		// await set(ref(db, `offers/allOffers/${offerId}`), miniOfferData);

		/* ================= CATEGORY INDEX ================= */
		// await set(
		// 	ref(
		// 		db,
		// 		`offers/byCategory/${cleanCategory}/${cleanSubCategory}/${offerId}`,
		// 	),
		// 	miniOfferData,
		// );

		/* ================= CATEGORY ALL INDEX ================= */
		// await set(
		// 	ref(db, `offers/byCategory/${cleanCategory}/all/${offerId}`),
		// 	miniOfferData,
		// );

		/* ================= ACTIVE INDEX ================= */
		// await set(ref(db, `offers/activeOffers/${offerId}`), miniOfferData);

		return {
			success: true,
			message: "Offer saved successfully",
		};
	} catch (error) {
		console.error(error);
		throw error;
	}
};
